module.exports = __webpack_public_path__ + "static/img/tabmode.4e1d9b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabmode.png
// module id = 1680
// module chunks = 1